import { Component, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Organisation } from 'src/app/models/organisation';
import { WorkgroupInformationModel, WorkgroupList } from 'src/app/models/workgroup-information.model';
import { IdentityWorkgroupsService } from 'src/app/services/identityWorkgroups.service';
import { AddEditWorkgroupComponent } from '../../add-edit-workgroup/add-edit-workgroup.component';
import { LoggingService } from 'src/app/services/logging.service';
import { SettingsService } from '../../settings.service';
import { Subscription } from 'rxjs';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdsForSettingsService } from '../../ids-for-settings.service';

@Component({
  templateUrl: './settings-organisation-workgroups.page.html'
})
export class SettingsOrganisationWorkgroupsPage implements OnDestroy {

  selectedOrganisationId: string = "";
  organisationIdSubscription: Subscription;

  workgroups: WorkgroupInformationModel[] = [];
  workgroupList: WorkgroupList[] = [];
  filter: string = '';
  organisation: Organisation = new Organisation;

  get HasWorkgroups(): boolean {
    return this.workgroups && this.workgroups.length > 0
  }

  constructor(
    private idsForSettingsService: IdsForSettingsService,
    private organisationApiClient: IdentityOrganisationApiClient,
    private workgroupService: IdentityWorkgroupsService,
    private modalService: NgbModal,
    private loggingService: LoggingService,
    private settingsBreadCrumbService: SettingsBreadCrumbService) {
      this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
          this.selectedOrganisationId = organisationId;
          // setup specialised breadcrumb with organisationId
          this.settingsBreadCrumbService.SetOrganisationCrumbs(BreadCrumbOptions.Organisation_Workgroups(this.selectedOrganisationId));


      this.organisationApiClient.getOrganisation(organisationId).subscribe(organisationData => {
        this.organisation = organisationData;
        if (this.organisation && this.organisation.organisation) {
          this.refresh();
        }
      });

    });
  }
  ngOnDestroy(): void {
    this.organisationIdSubscription.unsubscribe();
  }

  applyFilter(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
  }

  refresh() {
    this.getWorkgroups().catch((error) => this.loggingService.logException(error));
  }

  dialogWorkgroup(action: string) {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'lg',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(AddEditWorkgroupComponent, ngbModalOptions);
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.workgroupList = this.workgroupList;
    modalRef.componentInstance.organisationGuid = this.organisation.organisation.guid;
    modalRef.closed.subscribe({
      error: () => {
        this.refresh();
      },
      next: () => {
        this.refresh();
      }
    });
  }

  private async getWorkgroups() {
    this.workgroupList = [];
    (await this.workgroupService.getWorkgroups(this.organisation.organisation.guid)).subscribe({
      next: (data: any) => {
        this.workgroups = data;

        for (let item of this.workgroups as any) {
          this.workgroupList.push(item.name.toLowerCase());

          if (item.workgroupMembers.length > 0) {
            item.members = item.workgroupMembers.length;
          } else {
            item.members = 0;
          }
        }
      }
    });
  }
}
